enum RenderEngine {
  HOPPERMATION = 'HOPPERMATION',
  POSTMARK = 'POSTMARK'
}

export default RenderEngine
